import { render, staticRenderFns } from "./NoneReportTraderComplementModal.vue?vue&type=template&id=588b2a22&scoped=true&"
import script from "./NoneReportTraderComplementModal.vue?vue&type=script&lang=js&"
export * from "./NoneReportTraderComplementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b2a22",
  null
  
)

export default component.exports